
import axios from 'axios'
import sendformData from '../utils/form-data'
import mapResponse from '../utils/map-response'

export default class Services {

  private readonly baseUrl = `${process.env.VUE_APP_BEEREADERS_API_URL}/`;
  private module: string | undefined = '';

  constructor (module?: string) {
    this.module = module
  }

  public get (url: string, params?: object) {
    const response = mapResponse(axios.get(this.getUrl(url), params)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.get(this.getUrl(url), params))
        }
        return null
      })
    return response
  }

  public post (url: string, data?: object) {
    const response = mapResponse(axios.post(this.getUrl(url), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.post(this.getUrl(url), data))
        }
        return null
      })
    return response
  }

  public put (url: string, data?: object) {
    const response = mapResponse(axios.put(this.getUrl(url), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url), data))
        }
      })
    return response
  }

  public delete (url: string, data?: object) {
    const response = mapResponse(axios.delete(this.getUrl(url), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url), data))
        }
      })
    return response
  }

  public form (url: string, data?: object, transf?: object) {
    const response = sendformData(this.getUrl(url), data, transf).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return sendformData(this.getUrl(url), data, transf)
        }
      })
    return response
  }

  public bGet (url: string, params?: object) {
    const response = mapResponse(axios.get(this.getUrl(url, true), params)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.get(this.getUrl(url, true), params))
        }
      })
    return response
  }

  public bPost (url: string, data?: object) {
    const response = mapResponse(axios.post(this.getUrl(url, true), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.post(this.getUrl(url, true), data))
        }
      })
    return response
  }

  public bPut (url: string, data?: object) {
    const response = mapResponse(axios.put(this.getUrl(url, true), data)).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return mapResponse(axios.put(this.getUrl(url, true), data))
        }
      })
    return response
  }

  public bForm (url: string, data?: object, transf?: object) {
    const response = sendformData(this.getUrl(url, true), data, transf).then((res: any) => { return res })
      .catch((err: any) => {
        if (err.code === 'auth/updated-info') {
          return sendformData(this.getUrl(url, true), data, transf)
        }
      })
    return response
  }

  private getUrl (url: string, onlyBase = false) {
    return `${this.baseUrl}${onlyBase ? url : this.checkModule(url)}`
  }

  private checkModule (url: string) {
    return (this.module ? (url === '' ? `${this.module}` : `${this.module}/`) : '') + url
  }
}
